module.exports = __webpack_public_path__ + "img/piggy-bank-women.edd2e10.jpg";